import { Button } from 'shards-react'
import jsPDF from 'jspdf'
import 'jspdf-autotable'
import React from 'react'
import addFont from '../../../../fonts/fonts'

export const StudentsTotalPdfPrint = ({ data, searchFormValue, librariesList }) => {
  // const monthsList = [
  //   '',
  //   ' Январь',
  //   ' Февраль',
  //   ' Март',
  //   ' Апрель',
  //   ' Май',
  //   ' Июнь',
  //   ' Июль',
  //   ' Август',
  //   ' Сентябрь',
  //   ' Октябрь',
  //   ' Ноябрь',
  //   ' Декабрь',
  // ]

  const title = 'Численность переменного состава'
  const orientation = 'portrait'

  const buildColumnStyles = doc => {
    const table = document.getElementById('studentsTotalPDFTable')
    const headerRow = table?.querySelector('thead tr:nth-child(2)')
    const columnsCount = headerRow?.children.length || 0

    const numberColWidth = 8
    const nameColWidth = 40
    const countColWidth = 22
    const totalColWidth = 12

    const styles = {
      0: { cellWidth: numberColWidth },
      1: { cellWidth: nameColWidth },
      2: { cellWidth: countColWidth },
    }

    if (!columnsCount) return styles

    const classColumnsCount = Math.max(columnsCount - 4, 0)
    const totalColumnIndex = columnsCount - 1
    const pageWidth = doc.internal.pageSize.getWidth()
    const marginLeft = 5
    const marginRight = 5
    const fixedColumnsWidth = numberColWidth + nameColWidth + countColWidth + totalColWidth
    const availableWidth = Math.max(pageWidth - marginLeft - marginRight - fixedColumnsWidth, 40)
    const classColumnWidth = classColumnsCount ? Math.max(8, availableWidth / classColumnsCount) : 12

    for (let i = 0; i < classColumnsCount; i++) {
      styles[i + 3] = { cellWidth: classColumnWidth }
    }

    styles[totalColumnIndex] = { cellWidth: totalColWidth }

    return styles
  }

  const createDocData = async () => {
    addFont(jsPDF.API)

    const doc = new jsPDF({ putOnlyUsedFonts: true, orientation: orientation })

    // doc.setFont('Montserrat')
    // doc.setFontType('bold')
    // doc.setFontSize('16')

    // doc.text('ДНЕВНИК БИБЛИОТЕКИ', doc.internal.pageSize.width / 2, 10, null, null, 'center')

    // doc.setFontType('normal')
    // doc.setFontSize('13')

    // doc.text('высшего профессионального образования', doc.internal.pageSize.width / 2, 26, null, null, 'center')

    doc.autoTable({
      html: '#studentsTotalPDFTable',
      styles: { font: 'Montserrat', fontSize: 6, margin: 0 },
      headStyles: {
        halign: 'center',
        valign: 'middle',
        lineWidth: 0.2,
        lineColor: 100,
        fontSize: 7,
      },
      bodyStyles: {
        halign: 'center',
        valign: 'middle',
        lineWidth: 0.2,
        lineColor: 100,
        fontSize: 8,
        textColor: '#000',
      },
      columnStyles: buildColumnStyles(doc),
      didParseCell: function (table) {
        // if (table.row.raw[0].content === 'Разница') {
        //   table.cell.styles.lineWidth = { bottom: 0.5, right: 0.2 }
        // }
        // if (table.row.raw[table.row.raw.length - 1].content === table.cell.text[0] && table.section === 'body') {
        //   table.cell.styles.lineWidth = { bottom: 0.2, right: 0.5 }
        // }
        // if (table.row.raw[table.row.raw.length - 1].content === table.cell.text[0] && table.row.raw[0].content === 'Разница') {
        //   table.cell.styles.lineWidth = { bottom: 0.4, right: 0.5 }
        // }

        // if (table.row.raw[0].content > 0 && table.row.raw[1].content === table.cell.text.join(' ')) {
        //   table.cell.styles.lineWidth = { bottom: 0.4, right: 0.2 }
        //   console.log(table)
        // }

        // if (table.row.raw[0].content > 0 && table.row.raw[0].content === table.cell.text.join(' ')) {
        //   table.cell.styles.lineWidth = { bottom: 0.4, right: 0.2, left: 0.5 }
        // }

        if (table.cell.text[0] === '') {
          table.cell.styles.fillColor = '#d1d1d1'
        }
        // && (table.column.dataKey === 10 || table.column.dataKey === 11)
        if (table.cell.text[0] < 0 && table.row.raw[0].content === 'Некомплект') {
          table.cell.styles.textColor = 'green'
        }
        if (table.cell.text[0] > 0 && table.row.raw[0].content === 'Некомплект') table.cell.styles.textColor = 'red'
        if (
          table.cell.text[0] === 0 &&
          (table.row.raw[0].content > 0 || table.row.raw[0].content === 'Списочная' || table.row.raw[0].content === 'Некомплект')
        ) {
          table.cell.text[0] = ''
        }
      },
      // startY: doc.pageCount > 1 ? doc.autoTableEndPosY() + 20 : 70,
      margin: {
        left: 5,
        right: 5,
      },
    })
    doc.addPage('a4', orientation)
    doc.deletePage(doc.getCurrentPageInfo().pageNumber)
    return doc
  }

  const toPdf = () => {
    createDocData().then(doc => doc.save(`${title}.pdf`))
  }

  const toPrint = () => {
    createDocData().then(doc => {
      doc.autoPrint()
      doc.output('dataurlnewwindow')
    })
  }

  return (
    <>
      {/* <span onClick={toPdf}>PDF</span>
      <div>|</div> */}
      {/* <button onClick={toPrint} title={'Печать'} style={{ backgroundImage: 'url(' + printIcon + ')' }} /> */}
      <Button theme='danger' className={'mb-2'} onClick={toPrint}>
        Печать .pdf
      </Button>
      &nbsp;
      <Button theme='danger' className={'mb-2'} onClick={toPdf}>
        Скачать .pdf
      </Button>
    </>
  )
}
